import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import BounceBall from './components/BounceBall';
import AppErrorBoundary from './components/AppErrorBoundary';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
      {/* Outside App, which returns early for the platform pages — the ball is
          the platform's, so it belongs everywhere the platform does. */}
      <BounceBall />
    </AppErrorBoundary>
  </StrictMode>,
);

/*
 * A page that opened from the cached shell can be one deploy behind, and the
 * deploy may have removed a lazily-loaded page it has not fetched yet. Vite
 * reports that as vite:preloadError; reloading picks up the current shell
 * instead of leaving a broken screen. Once per minute at most, so a genuinely
 * missing file cannot loop.
 */
window.addEventListener('vite:preloadError', (event) => {
  try {
    const last = Number(sessionStorage.getItem('reloaded-for-deploy') ?? 0);
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem('reloaded-for-deploy', String(Date.now()));
  } catch {
    // Storage unavailable: still reload, once is the usual case.
  }
  event.preventDefault();
  window.location.reload();
});

// Register the service worker for the installable PWA. Production only, so the
// dev server is never shadowed by a cached shell.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // A failed registration must never break the app.
    });
  });
}
